// Adds a cache layer over the {fn} that returns previously stored result of the {fn} call
// if the result exists.
const _generateKeyDefault = (...args) => args.toString();
export const applyCacheToFn = (
  cacheManager, fn,
  fnGenerateKey = _generateKeyDefault, staleTimeInMilliseconds,
) => {
  const _cacheResult = (key, result, timestamp) => {
    cacheManager.set(key, { result, timestamp });
  };

  return {
    get: async (...args) => {
      const key = fnGenerateKey(...args);
      const timestamp = Date.now();

      if (cacheManager.has(key)) {
        const cacheData = cacheManager.get(key);

        if (cacheData) {
          if (!staleTimeInMilliseconds || timestamp - cacheData.timestamp < staleTimeInMilliseconds) {
            return cacheData.result;
          }
        }
      }

      const result = await fn(...args);
      _cacheResult(key, result, timestamp);
      return result;
    },
    cache: (args, result) => {
      _cacheResult(fnGenerateKey(...args), result, Date.now());
    },
  };
};

export const applyRuntimeCacheToFn = (fn, fnGenerateKey, staleTimeInMilliseconds) => {
  return applyCacheToFn(new Map, fn, fnGenerateKey, staleTimeInMilliseconds);
};

export const debounce = (func, timeout) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
};

export const throttle = (func, timeout) => {
  let isCallAllowed = true;

  return (...args) => {
    if (isCallAllowed) {
      func.apply(this, args);
      isCallAllowed = false;
      setTimeout(() => { isCallAllowed = true; }, timeout);
    }
  };
};

export const trottleCheck = (trottle, lastAction = Date.now()) => {
  return trottle === 0 || (trottle > 0 && Date.now() - lastAction > trottle);
};
